
import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@/contexts/ThemeContext';
import { Heart, Twitter, MessageSquare } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
import FeedbackForm from './FeedbackForm';
import { useState } from 'react';

const Footer: React.FC = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const currentYear = new Date().getFullYear();
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  return (
    <footer className={cn(
      "py-6 border-t w-full",
      isDark 
        ? "bg-[#0F1225] border-slate-800/30 text-slate-300" 
        : "bg-white border-slate-200/50 text-slate-600"
    )}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center justify-between space-y-4 md:flex-row md:space-y-0">
          <div className="text-center md:text-left text-sm">
            <p>
              © {currentYear} Chatrix.  | Made with <Heart className="inline h-3 w-3 text-red-500" /> by Alok Mishra
            </p>
          </div>
          
          <div className="flex items-center space-x-4">
            <Link to="/terms" className="text-xs hover:underline">
              Terms of Service
            </Link>
            <Link to="/privacy" className="text-xs hover:underline">
              Privacy Policy
            </Link>
            <Dialog open={feedbackOpen} onOpenChange={setFeedbackOpen}>
              <DialogTrigger asChild>
                <button className={cn(
                  "text-xs hover:underline flex items-center gap-1",
                  isDark ? "text-slate-400 hover:text-white" : "text-slate-600 hover:text-slate-900"
                )}>
                  <MessageSquare size={12} />
                  <span>Give us feedback</span>
                </button>
              </DialogTrigger>
              <DialogContent className={cn(
                "sm:max-w-md",
                isDark ? "bg-[#151833]/95 border-[#292D67]/30" : "bg-white/95 border-gray-200"
              )}>
                <FeedbackForm onClose={() => setFeedbackOpen(false)} />
              </DialogContent>
            </Dialog>
            <Button
              variant="ghost"
              size="icon"
              className={cn(
                "h-8 w-8",
                isDark
                  ? "text-slate-400 hover:text-white hover:bg-slate-800"
                  : "text-slate-500 hover:text-slate-900"
              )}
              asChild
            >
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer"
              >
                <Twitter className="h-4 w-4" />
                <span className="sr-only">Twitter</span>
              </a>
            </Button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
